import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { IMAGES } from "@/data/site";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="relative min-h-screen flex items-center justify-center px-5">
      <img src={IMAGES.mountains} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0B0F14]/85 backdrop-blur-sm" />
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative glass rounded-3xl p-8 sm:p-10 w-full max-w-md"
      >
        <div className="flex justify-center mb-8">
          <Logo compact />
        </div>
        <h1 className="font-sora text-2xl font-bold text-center">Admin Sign In</h1>
        <p className="text-sm text-[#F5F5F0]/55 text-center mt-2 mb-8">
          Enquiries, bookings and subscribers — all in one place.
        </p>
        <label className="block mb-4">
          <span className="text-xs uppercase tracking-[0.18em] text-[#F5F5F0]/50 font-semibold">Email</span>
          <div className="relative mt-2">
            <Mail size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#3FB6D3]" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="oregotours@gmail.com"
              data-testid="admin-email-input"
              className="input-dark !pl-11"
            />
          </div>
        </label>
        <label className="block mb-6">
          <span className="text-xs uppercase tracking-[0.18em] text-[#F5F5F0]/50 font-semibold">Password</span>
          <div className="relative mt-2">
            <Lock size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#3FB6D3]" />
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              data-testid="admin-password-input"
              className="input-dark !pl-11"
            />
          </div>
        </label>
        {error && (
          <p data-testid="admin-login-error" className="text-sm text-red-400 bg-red-400/10 border border-red-400/25 rounded-xl px-4 py-3 mb-5">
            {error}
          </p>
        )}
        <button type="submit" disabled={busy} data-testid="admin-login-button" className="btn-gold w-full disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </main>
  );
};

export default AdminLogin;
